<!-- Modified container with navigation buttons -->
<div class="container-fluid">
  <!-- New navigation header -->
  <div class="nav-header mb-3">
    <div class="nav-buttons">
      <button class="btn btn-light nav-btn" title="Configuration" (click)="navigateToConfiguration(projectId)">
        <i class="fa fa-gear"></i>
        <span>Configuration</span>
      </button>
      <button class="btn btn-light nav-btn" title="Knowledge Base" (click)="navigateToKnowledgeBase(projectId)">
        <i class="fa fa-book"></i>
        <span>Knowledge Base</span>
      </button>
      <button class="btn btn-light nav-btn" title="Dashboard Analytics">
        <i class="fa ft-bar-chart"></i>
        <span>Analytics</span>
      </button>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <h2>You are in {{projectId}}'s Workspace</h2>
      <p>Continue from a previous session, upload a workspace file, or start a new story</p>
    </div>
    <div class="card-body">
      <!-- File Upload Section -->

      <app-test-file-upload
        [templates]="templates"
        [activeUploadMethod]="activeUploadMethod"
        [projectId]="projectId"
        (activeUploadMethodChange)="handleUploadMethodChange($event)"
        (templateSelected)="onTemplateSelected($event)">
      </app-test-file-upload>


      <div class="mt-4 text-center">
        <button class="btn btn-secondary" (click)="continueWithoutSession()">
          <i class="fa fa-pencil"></i> Start New Session
        </button>
      </div>

      <!-- Divider -->
      <hr class="my-4">

      <!-- Saved Sessions Section -->
      <div *ngIf="loading" class="text-center p-4">
        <div class="spinner-border text-primary" role="status">
        </div>
        <p class="mt-2">Loading sessions...</p>
      </div>

      <div *ngIf="!loading && sessions.length === 0" class="empty-state">
        <i class="fa fa-folder-open"></i>
        <p>No saved sessions found for this project.</p>
        <button class="btn btn-primary mt-3" (click)="continueWithoutSession()">
          Start New Session
        </button>
      </div>

      <div *ngIf="!loading && sessions.length > 0" class="sessions-container">
        <h4 class="mb-3">Past Sessions</h4>
        <div class="table-responsive sessions-list">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Session Name</th>
              <th>Checkpoint</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Last Modified</th>
              <!-- **** START MODIFICA: Aggiunta colonna Share e rinominata Actions in Delete **** -->
              <th class="text-center">Share</th>
              <th class="text-center">Delete</th>
              <!-- **** END MODIFICA **** -->
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let session of sessions"
                (click)="loadSession(session.sessionId)"
                data-session-id="{{session.sessionId}}"
                class="session-row">
              <td>{{ session.displayName }}</td>
              <td>
                  <span class="badge"
                        [ngClass]="{
                          'bg-info': session.checkpointStage === 'scenarios',
                          'bg-warning': session.checkpointStage === 'acs',
                          'bg-success': session.checkpointStage === 'tests'
                        }">
                    {{ getCheckpointStageName(session.checkpointStage) }}
                  </span>
              </td>
              <td>{{ session.createdBy }}</td>
              <td>{{ getFormattedDate(session.createdAt) }}</td>
              <td>{{ getFormattedDate(session.lastModified) }}</td>
              <!-- **** START MODIFICA: Aggiunta cella per i pulsanti di condivisione **** -->
              <td class="text-center">
                <!-- Pulsante per ABILITARE la condivisione -->
                <button *ngIf="!session.isShared"
                        (click)="shareSession(session, $event)"
                        class="btn btn-sm btn-outline-primary"
                        title="Share this session">
                  <i class="fa fa-share-alt"></i>
                </button>

                <!-- Controlli per una sessione GIÀ condivisa -->
                <div *ngIf="session.isShared && session.shareId">
                  <div class="d-flex flex-column align-items-center">
                    <!-- Mostra la data di scadenza -->
                    <small class="mb-1" [title]="'Expires on ' + (session.shareExpiresAt | date:'full')">
                      Expires: {{ session.shareExpiresAt | date:'dd/MM/yy' }}
                    </small>
                    <div class="btn-group" role="group">
                      <!-- Pulsante per estendere la condivisione -->
                      <button (click)="copyShareLink(session.shareId, $event)"
                              class="btn btn-sm btn-success"
                              title="Copy share link">
                        <i class="fa fa-copy"></i>
                      </button>
                      <button (click)="unshareSession(session, $event)"
                              class="btn btn-sm btn-outline-danger"
                              title="Stop sharing">
                        <i class="fa fa-ban"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </td>

              <td class="text-center">
                <!-- This button's icon was already working -->
                <button class="btn btn-sm btn-danger" (click)="deleteSession(session.sessionId, $event)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>


            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
